<template>
  <attachment-image :attachment="attachment" @togglePreview = "$emit('togglePreview')"></attachment-image>
</template>

<script>
import AttachmentImage from './Image'

export default {
  props: ['attachment'],
  components: {
    AttachmentImage
  }
}
</script>
